import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: {} as SxProps<Theme>,
};
